export default function assetUrl(path) {
  return `/${process.env.NEXT_PUBLIC_BRAND}/${path}`;
}
